//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
// import { I18nUtil } from '@/shared/i18n/i18n-util';
import i18n from '@/vueI18n'
import { getLanguages, getLanguageCode, setLanguageCode } from '@/i18n';
import Quasar from 'quasar'

export default {
  name: 'app-i18n-select',

  data() {
    return {
      value: getLanguageCode(),
      objValues: {},
    };
  },

  computed: {
    // languages() {
    //   return getLanguages();
    // },

    languages() {
      const languages = getLanguages().map((lang) => {
        let obj = {
          key: lang.id,
          label: lang.label,
          value: lang.id,
          icon: lang.secondFlag,
        };
        return obj;
      });
      return languages;
    },
  },

  methods: {
    ...mapActions({
      changeCurrentLanguageCode: 'layout/changeCurrentLanguageCode',
    }),
    // doChangeLanguage(language) {
    //   I18nUtil.doChangeLanguage(language);
    // },
    doChangeLanguage(language) {
      i18n.locale = language;
      localStorage.setItem('language', language);
      setLanguageCode(language)
      this.changeCurrentLanguageCode(language)

      // const { lang } = this.$route.params;
      // let route = '';
      // if (lang && (lang === 'ar' || lang === 'en')) {
      //   route = `/${language}${this.$route.fullPath.substring(3)}`;
      // } else {
      //   route = `/${language}${this.$route.fullPath}`;
      // }

      if (language === 'ar') {
        import(`quasar/lang/ar`).then((lang) => {
          // eslint-disable-next-line
          Quasar.lang.set(lang.default);
        });
      } else {
        import(`quasar/lang/en-us`).then((lang) => {
          // eslint-disable-next-line
          Quasar.lang.set(lang.default);
        });
      }
      // this.$router.push(route);
      // I18nUtil.doChangeLanguage(language);
    },
  },
};
